import { ColorScheme, Vertical, VerticalConfig, VerticalConfigs } from 'utils/vertical';
import { SUPPORTED_MESSAGING_LOCALES } from 'providers/messaging/constants';
import {
  ARTISTS_SMARTLING_LOCALES,
  CONSUMER_SMARTLING_LOCALES,
  PODCASTERS_SMARTLING_LOCALES,
} from 'utils/i18n/localeConfig';

// These configs might be available in frontend, so don't add anything sensitive like secrets etc
const verticalConfigs: VerticalConfigs = {
  [Vertical.ARTISTS]: {
    verticalName: Vertical.ARTISTS,
    pathParam: 'artists',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_ARTIST_DATASET ?? 'artists_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: null,
      showHeaderGradient: false,
      configureMasthead: {
        header: 's4a',
        footer: 's4a',
      },
      configurePillowTalk: {
        lineOfBusiness: 'S4A',
        redirectUri: 'https://support.spotify.com/artists/contact-spotify-anonymous/',
        showLoginDialog: true,
      },
      emailMessagingFallback: false,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.ARTISTS],
      smartling: ARTISTS_SMARTLING_LOCALES,
    },
    theme: 'encore-creator-light-theme',
    colorScheme: ColorScheme.LIGHT,
    rolloutConfig: null,
  },
  [Vertical.CONSUMER]: {
    verticalName: Vertical.CONSUMER,
    pathParam: '',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_CONSUMER_DATASET ?? 'production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: 'https://community.spotify.com/t5/Spotify-Answers/tkb-p/Spotify-Answers',
      showHeaderGradient: true,
      configureMasthead: null,
      configurePillowTalk: null,
      emailMessagingFallback: true,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.CONSUMER],
      smartling: CONSUMER_SMARTLING_LOCALES,
    },
    theme: 'encore-dark-theme',
    colorScheme: ColorScheme.DARK,
    rolloutConfig: null,
  },
  [Vertical.PODCASTERS]: {
    verticalName: Vertical.PODCASTERS,
    pathParam: 'podcasters',
    cms: {
      dataset: process.env.NEXT_PUBLIC_VERTICAL_PODCASTERS_DATASET ?? 'podcasters_production',
      projectId: 'tsbk0zvv',
      apiVersion: '2021-10-21',
    },
    features: {
      communityLink: null,
      showHeaderGradient: false,
      configureMasthead: {
        footer: 'turnkey',
        header: 'turnkey',
      },
      configurePillowTalk: {
        lineOfBusiness: 'S4P',
        redirectUri: 'https://support.spotify.com/podcasters/contact-spotify-anonymous/',
        showLoginDialog: false,
      },
      emailMessagingFallback: false,
    },
    locales: {
      messagingLocales: SUPPORTED_MESSAGING_LOCALES[Vertical.PODCASTERS],
      smartling: PODCASTERS_SMARTLING_LOCALES,
    },
    theme: 'encore-s4p-light-theme',
    colorScheme: ColorScheme.LIGHT,
    rolloutConfig: null,
  },
} as const;

export const getVerticalConfigs = (): VerticalConfigs => verticalConfigs;

export const getVerticalConfig = (vertical: Vertical): VerticalConfig => {
  return verticalConfigs[vertical];
};
